import { Trans } from "react-i18next";

import { Link } from "./components";

const News6 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##6"}
            components={{
                section: <section />,
                p: <p />,
                strong: <strong />,
                a: (
                    <Link href="https://wiki.teltonika-gps.com/view/FOTA_WEB_Users">
                        ""
                    </Link>
                )
            }}
        />
    );
};

export { News6 };
